import { featureCardDecorationEllipse } from "assets/landing/features";
import clsx from "clsx";
import React, { PropsWithChildren, useState } from "react";
import { useMediaQuery } from "usehooks-ts";
import crossIcon from "assets/landing/cross-icon.svg";

const COLORS = ["#FFA686", "#CFB2FF", "#FFDF86"];

type FeatureCardProps = {
  cardClasses?: string;
  analytics?: String[];
  isSecondRow?: boolean;
};

const FeatureCard: React.FC<PropsWithChildren<FeatureCardProps>> = ({
  children,
  cardClasses = "",
  analytics,
  isSecondRow = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const matches = useMediaQuery("(min-width: 1024px)");

  const handleOpen = () => {
    if (matches) {
      return;
    }
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <article
      onClick={(e) => {
        e.stopPropagation();
        handleOpen();
      }}
      className={clsx(
        "bg-[#F3F3F8] cursor-pointer flex-1 group relative overflow-hidden linear-border custom-shadow",
        cardClasses,

        "w-[28.61vw] max-w-[28.61vw] h-[28.4vw] p-[0.83vw] pb-[1.55vw] rounded-[1.94vw]", 

        "max-lg:w-[93.6vw] max-lg:max-w-[93.6vw] max-lg:h-[90.65vw] max-lg:p-[3.2vw] max-lg:rounded-[7.4vw] max-lg:gap-[2.1vw]"
      )}
    >
      <div>{children}</div>
    </article>
  );
};

export default FeatureCard;
